export function MaskReal(value) {
  var valueFloat = parseFloat(value).toFixed(2)

  var tmp = valueFloat
    .toString()
    .replace(/\D/g, '')
    .replace(/([0-9]{2})$/g, ',$1')
  if (tmp.length > 6) tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2')

  return 'R$ ' + tmp
}

export function normaliseValue(value, decimals = 2) {
  if (!value) return ''

  if (value === '.') return '0.'

  const regex = new RegExp(`^-?\\d+(?:\\.\\d{0,${decimals}})?`)
  const decimalsNumber = value.toString().match(regex)[0]

  let parsed = parseFloat(decimalsNumber).toFixed(decimals)

  parsed = parsed.replace('.', ',')

  const parts = parsed.split(',')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  return parts.join(',')
}

export function formatarDataParaAnoMesDia(value) {
  if (value === undefined || value === null || ('' + value).indexOf('/') <= 0) return value
  let dataSplit = value.split('/')
  return dataSplit[2] + '-' + dataSplit[1] + '-' + dataSplit[0]
}

export function formatarDataParaDiaMesAno(value) {
  if (value === undefined || value === null || ('' + value).indexOf('-') <= 0) return value
  let dataSplit = value.split('-')
  return dataSplit[2] + '/' + dataSplit[1] + '/' + dataSplit[0]
}

export function CpfIsValid(value) {
  var Soma
  var Resto
  Soma = 0
  if (value == '00000000000') return false
  for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(value.substring(i - 1, i)) * (11 - i)
  Resto = (Soma * 10) % 11

  if (Resto == 10 || Resto == 11) Resto = 0
  if (Resto != parseInt(value.substring(9, 10))) return false

  Soma = 0
  for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(value.substring(i - 1, i)) * (12 - i)
  Resto = (Soma * 10) % 11

  if (Resto == 10 || Resto == 11) Resto = 0
  if (Resto != parseInt(value.substring(10, 11))) return false
  return true
}
export function abbreviateNumber(number) {
  var SI_SYMBOL = ['', 'k', 'M', 'G', 'T', 'P', 'E']

  var tier = (Math.log10(Math.abs(number)) / 3) | 0
  if (tier == 0) return number.toFixed(1)
  var suffix = SI_SYMBOL[tier]
  var scale = Math.pow(10, tier * 3)
  var scaled = number / scale
  return scaled.toFixed(1) + suffix
}
export function isValidTelefone(telefone) {
  const telefoneNumerico = telefone.replace(/\D/g, '')
  return telefoneNumerico.length === 10 || telefoneNumerico.length === 11
}
export function isValidCnpj(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '')

  if (cnpj === '') return false

  if (cnpj.length !== 14) return false
  if (
    cnpj === '00000000000000' ||
    cnpj === '11111111111111' ||
    cnpj === '22222222222222' ||
    cnpj === '33333333333333' ||
    cnpj === '44444444444444' ||
    cnpj === '55555555555555' ||
    cnpj === '66666666666666' ||
    cnpj === '77777777777777' ||
    cnpj === '88888888888888' ||
    cnpj === '99999999999999'
  ) {
    return false
  }
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0, tamanho)
  let digitos = cnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(digitos.charAt(0), 10)) return false

  tamanho += 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(digitos.charAt(1), 10)) return false

  return true
}

export function isValidEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}
export function isValidFirstNameAndLastName(name) {
  let firstNameAndLastName = name.split(' ')
  if (firstNameAndLastName.length >= 2) {
    for (let i = 0; i < firstNameAndLastName.length; i++) {
      if (firstNameAndLastName[i].trim() === '') {
        return false
      }
    }
    return true
  } else {
    return false
  }
}

export function formatTelefone(telefone) {
  const cleaned = telefone.replace(/\D/g, '')
  const match = cleaned.match(/^(\d{2})(\d{4,5})(\d{4})$/)
  if (match) {
    const prefix = match[2].length === 5 ? `${match[2].substring(0, 4)}${match[2].substring(4)}` : match[2]
    return `(${match[1]})${prefix}-${match[3]}`
  }
  return telefone
}

export function formatCnpj(cnpj) {
  if (!cnpj) return ''
  const cleaned = cnpj.replace(/\D/g, '')
  const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/)
  if (match) {
    return `${match[1]}.${match[2]}.${match[3]}/${match[4]}-${match[5]}`
  }
  return cnpj
}
